<template lang="pug">
vm-col(class="table_dashboard" vm-sm=12)
  vm-table(v-model="selected"  max-height="350px" :data="data" )
    template(slot="thead")
      vm-th(:key="index" v-for="(column, index) in columns") {{ $t('invoices.' + column) }}
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
        vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
          .details(@click="selectData(data[indextr])")
            slot(v-if="column == 'total' || column == 'unit_price' || column == 'tax_amount' || column == 'subtotal'")  {{data[indextr][column] | currency }}
            slot(v-if="column == 'currency'")  {{data[indextr]['purchase_order']['currency_display']}}
            slot(v-if="column == 'currency_payment'")  {{data[indextr]['invoice']['purchase_order']['currency_display']}}
            slot(v-if="column == 'created_at' || column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
            slot(v-if="column != 'status' && column != 'created_at' && column != 'date' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price' && column != 'tax_amount' && column != 'subtotal'") {{data[indextr][column]}}
            vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{ $t('invoices.'+ data[indextr]['status']) }}
        vm-td
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')
export default {
  name: 'ProjectTablesDashboard',
  mixins: [ViewMixinMaster1],
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    columns: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Object,
      default: () => ({})
    },
    typeSelect: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([]),
    selectData (data) {
      this.typeSelect && this.$emit(this.typeSelect, data)
    }
  }
}
</script>
<style lang="scss">
.table_dashboard {
  margin: 5px;
  background: white;
  padding: 25px;
  border-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  .vm-table--tbody-table .tr-table tr {
    color: #5D6165;
  }
}
</style>
